<app-base-modal
  [title]="'Связка/Отвязка Карт продукта'"
>
  @if (isLoading) {
    <app-loader/>
  }
  <mat-tab-group>
    @for (tab of tabsData; track $index) {
      <mat-tab [label]="tab.title">
        @if (!getProductCardsDataByTab(tab.key).length) {
          <div class="sync-product-card-list-empty">
            {{ tab.emptyText }}
          </div>
        } @else {
          <app-carousel
            [itemsCount]="getProductCardsDataByTab(tab.key).length"
            [gap]="20"
            [visibleItems]="3"
            (currentIndexChange)="handleIndexChange($event)"
          >
            <div class="sync-product-card-list-cards">
              @for (productCard of getProductCardsDataByTab(tab.key); track $index) {
                <div
                  app-pc-sync-product-card
                  class="sync-product-card-list-card"
                  [productCardData]="productCard"
                  [btnKey]="tab.btnKey"
                  [currentParamKey]="currentParamKey()"
                  (handleBtnClick)="handleBtnClick($event, tab.btnKey)"
                ></div>
              }
            </div>
          </app-carousel>
        }
      </mat-tab>
    }
  </mat-tab-group>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
